import { CompactInlineAlertWidget, InlineAlertType, Tooltip } from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { tooltipMessage } from '~src/flow/components/FlowSuspendedIconWithTooltip';
import { cssClass } from '~src/style';

const rootClass = 'WarningBanner';

const borderRadiusValue: string = '4px';

export const WARNING_BANNER_TESTID = 'flows-warning-banner';
export const WARNING_BANNER_TOOLTIP_TESTID = 'warning-banner-tooltip';

const bannerWrapper = cssClass(rootClass, 'bannerWrapper', {
  display: 'flex',
  padding: 12,
  borderRadius: `${borderRadiusValue} 0 0 ${borderRadiusValue}`,
});

const errorIconStyle = cssClass(rootClass, 'errorIconStyle', {
  marginRight: 8,
});

export interface WarningBannerProps {
  message: string;
  tooltipMessages?: string[];
}

function getToolTipContent(messages: string[]) {
  return <>
    <div>
      { Messages.flowCannotBeRunForReasons() }
    </div>
    <ul>
    {messages.map((message) => (
      <li key={message}>{message}</li>
    ))}
    </ul>
  </>;
}

function getInfoAltContent(messages: string[]) {
  return  Messages.flowCannotBeRunForReasons() + '\n' + messages.map((message) => (message + '\n'));
}

export function WarningBanner(props: WarningBannerProps): JSX.Element {
  const icon = tooltipMessage !== undefined ?
    <Tooltip
      testId={WARNING_BANNER_TOOLTIP_TESTID}
      tooltipContent={getToolTipContent(props.tooltipMessages)}
    >
      <img
        src={imgPath('data_prep_info.svg')}
        alt={getInfoAltContent(props.tooltipMessages)} />
    </Tooltip>
    :
    undefined;
  return (
    <CompactInlineAlertWidget
      children={props.message}
      icon={icon}
      style={{display: 'inline-flex'}}
      testId={WARNING_BANNER_TESTID}
      type={InlineAlertType.Warning}
    />
  );
}
